import React, {useEffect, useRef, useState} from "react";
import "./ModalPrint.scss";
import {Button, Col, Modal, Row, Space, Table, Typography} from "antd";
import moment from "moment";
import ReactToPrint from "react-to-print";
import dayjs from "dayjs";
import {formatToCurrencyType} from "helper/common";
import {FORMAT_TIME} from "types/enums";
import {useAppSelector} from "redux/hooks";

const columnBKK: any = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "4%",
    fixed: "left",
    align: "center",
  },
  // {
  //   title: "Mã vật tư",
  //   dataIndex: "noiDung",
  //   key: "noiDung",
  //   align: "left",
  //   // width: "35%",
  // },
  {
    title: "Tên vật tư",
    dataIndex: "tenThuoc",
    key: "tenThuoc",
    align: "left",
    // width: "20%",
  },
  {
    title: "Đơn vị tính",
    dataIndex: "donViTinh",
    key: "donViTinh",
    align: "left",
    // width: "35%",
  },
  {
    title: "Ngày hết hạn",
    dataIndex: "ngayHetHan",
    key: "ngayHetHan",
    align: "center",
    // width: "35%",
  },
  {
    title: "Số lượng PM",
    dataIndex: "soLuongTonPM",
    key: "soLuongTonPM",
    align: "center",
    // width: "35%",
  },
  {
    title: "Số lượng thực",
    dataIndex: "soLuongThucNhap",
    key: "soLuongThucNhap",
    align: "left",
    // width: "35%",
  },
];

const {Text} = Typography;

const ModalPrint = props => {
  const {isShowModal, handleOk, handleCancel, dataTable, storeName} = props;
  const printRef = useRef<any>();
  const [thongTinIn, setThongTinIn] = useState<any>(null);
  const [column, setColumn] = useState(columnBKK);
  const [data, setData] = useState();
  const [kho, setKho] = useState<any>();
  const listStore = useAppSelector(state => state.pharmacyStore.listStore);

  useEffect(() => {
    setOptionsStore();
  }, [storeName, isShowModal, dataTable]);

  const setOptionsStore = () => {
    const options = listStore.map(e => ({value: e.id, label: e.name}));
    const khoName = options.find(item => item.value === storeName);
    if (khoName) {
      setKho(khoName.label);
    } else {
      setKho("");
    }
  };

  useEffect(() => {
    const newData = dataTable.map(e => ({
      ...e,
      ngayHetHan: e.ngayHetHan
        ? dayjs(e.ngayHetHan).format(FORMAT_TIME.dayFull)
        : "",
    }));
    setData(newData);
  }, [dataTable]);

  const getTodayString = () => {
    // const today = moment().format();
    const day = moment().format("DD");
    const month = moment().format("MM");
    const year = moment().format("YYYY");
    const time = moment().format("HH:mm A");
    return `Ngày ${day} tháng ${month} năm ${year}`;
  };

  const onPrint = async () => {
    window.print();
  };

  return (
    <Modal
      centered
      open={isShowModal}
      onCancel={handleCancel}
      closable={false}
      footer={null}
      width={1000}
      className="modal-custom-print-PKK"
    >
      <div className="print-phieu-kiem-ke print-form">
        <div ref={printRef} className="content">
          {/* <HeaderPrintForm /> */}
          <Row>
            <Row justify={"center"} style={{paddingTop: "20px"}}>
              <Typography.Title
                style={{
                  fontWeight: "700",
                  fontSize: "20px",
                  margin: 0,
                }}
              >
                Phiếu kiểm kê
              </Typography.Title>
            </Row>
            <Row justify={"center"}>
              <Typography.Text
                style={{
                  // fontWeight: "700",
                  fontSize: "16px",
                  margin: 0,
                }}
              >
                Người làm: {localStorage.getItem("fullName")}
              </Typography.Text>
            </Row>
            <Row justify={"center"}>
              <Typography.Text
                style={{
                  // fontWeight: "700",
                  fontSize: "16px",
                  margin: 0,
                }}
              >
                Kho: {kho ? kho : ""}
              </Typography.Text>
            </Row>
            <Row justify={"center"}>
              <Typography.Text
                style={{
                  // fontWeight: "700",
                  fontSize: "16px",
                  margin: 0,
                }}
              >
                Ngày in: {getTodayString()}
              </Typography.Text>
            </Row>
            <Row>
              <Table
                bordered
                className="table-bkk-custom table-print"
                style={{
                  width: "100%",
                  borderLeft: "1px solid #ededed",
                  borderTopLeftRadius: "12px",
                }}
                columns={column}
                dataSource={data}
                pagination={false}
              ></Table>
            </Row>
            <Row style={{paddingTop: "10px"}}>
              <Row justify={"end"}>
                <Typography.Text
                  className="date-sign"
                  italic
                  style={{marginRight: "35px"}}
                >
                  {getTodayString()}
                </Typography.Text>
              </Row>
              <Row justify={"end"}>
                <Col>
                  {/* <Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>
                          Người nhận
                        </Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text type="secondary" italic>
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                    </Row> */}
                </Col>
                <Col span={7}>
                  <Space direction="vertical" size={60}>
                    <Row>
                      <Row justify={"center"}>
                        <Typography.Text strong>Người nhận</Typography.Text>
                      </Row>
                      <Row justify={"center"}>
                        <Typography.Text type="secondary" italic>
                          (Ký và ghi rõ họ tên)
                        </Typography.Text>
                      </Row>
                    </Row>
                    <Row justify={"center"}>
                      <Typography.Text strong>
                        {thongTinIn?.tenThuNgan
                          ? thongTinIn?.tenThuNgan
                          : localStorage.getItem("fullName")}
                      </Typography.Text>
                    </Row>
                  </Space>
                </Col>
              </Row>
            </Row>
          </Row>
        </div>
      </div>
      <Row justify={"end"} style={{padding: "12px", gap: "4px"}}>
        <Space direction="horizontal">
          <Button danger type="primary" onClick={handleCancel}>
            HỦY
          </Button>
          <ReactToPrint
            trigger={() => {
              return (
                <Button type="primary" onClick={onPrint}>
                  IN
                </Button>
              );
            }}
            content={() => printRef.current}
            bodyClass="print-phieu-kiem-ke"
          />
        </Space>
      </Row>
    </Modal>
  );
};

export default ModalPrint;
